/* eslint react/jsx-key: off */
import React, { Component } from 'react';
import { AutocompleteInput, translate, required } from 'react-admin';
import axios from 'axios';
import {loobackApiUrl} from '../config';

class RoleEditField extends Component {
    constructor(props) {
	    super(props);
	    this.state = {role: ""};
	 }

    componentDidMount() {
    	const { record } = this.props;
        axios.get(loobackApiUrl + '/AppUsers/getRole?userId='+record.id).then(function (response) {
            this.setState({
	        	role: response.data.role
	      	});
        }.bind(this));
    }

    render() {
        return (
            <AutocompleteInput
                    source="role"
                    choices={[
                        { id: '', name: 'None' },
                        { id: 'PM', name: 'PM' },
                        { id: 'WM', name: 'WM' },
                        { id: 'Admin', name: 'Admin' }
                    ]}
                    validate={required()}
                    defaultValue={this.state.role}
            />
        );
    }
}

export default RoleEditField;
